import { render, staticRenderFns } from "./help_info.vue?vue&type=template&id=73048d9f&scoped=true"
import script from "./help_info.vue?vue&type=script&lang=js"
export * from "./help_info.vue?vue&type=script&lang=js"
import style0 from "./help_info.vue?vue&type=style&index=0&id=73048d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73048d9f",
  null
  
)

export default component.exports